import { render, staticRenderFns } from "./CreatePageBase.vue?vue&type=template&id=4ae80949&scoped=true"
import script from "./CreatePageBase.vue?vue&type=script&lang=js"
export * from "./CreatePageBase.vue?vue&type=script&lang=js"
import style0 from "./CreatePageBase.vue?vue&type=style&index=0&id=4ae80949&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae80949",
  null
  
)

export default component.exports